//获取商品限售规则
export const GET_LIMIT_RULES = "GET_LIMIT_RULES";
//设置商品限售规则
export const SET_LIMIT_RULES = "SET_LIMIT_RULES";

//删除限售规则
export const DELETE_LIMIT_RULE = "DELETE_LIMIT_RULE";

//获取商品限售规则详情
export const GET_LIMIT_RULE_DETAIL = "GET_LIMIT_RULE_DETAIL";
//设置商品限售规则详情
export const SET_LIMIT_RULE_DETAIL = "SET_LIMIT_RULE_DETAIL";

//获取卖家商品列表
export const GET_WARE_LISTS = "GET_WARE_LISTS";
//设置卖家商品列表
export const SET_WARE_LISTS = "SET_WARE_LISTS";

//新增限售规则
export const ADD_LIMIT_RULE = "ADD_LIMIT_RULE";

//获取省列表
export const GET_PROVINCE_LISTS = "GET_PROVINCE_LISTS";

//获取市列表
export const GET_CITY_LISTS = "GET_CITY_LISTS";

//设置区域列表(通过获取省/市列表设置区域列表)
export const SET_AREA_LISTS = "SET_AREA_LISTS";

//设置选中的区域
export const SET_SELECTED_WARE = "SET_SELECTED_WARE";

//设置表单
export const SET_FORM = "SET_FORM";

//设置选中区域
export const SET_SELECTED_AREA = "SET_SELECTED_AREA";

//设置是否刷新商品列表
export const SET_REFRESH_WARE = "SET_REFRESH_WARE";






// WEBPACK FOOTER //
// ./src/store/limit-sale/type.js